import React, { useEffect, useState } from "react";
import { Field, reduxForm } from "redux-form";
import Titlebanner from "../../../globel_cmponents/title_banner";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import RenderField from "../../formcomponent/formfields/RenderField";
import axios from "axios";
import requests from "../../../utils/Requests";
import Swal from "sweetalert2";
import RenderExcelUploadField from "./ExcelReader/RenderExcelUploadField";

const MealsTicketCreation = (props) => {
  const { handleSubmit } = props;
  const [mealsoption, setMealsoption] = useState([]);
  useEffect(() => {
    getmealOptionsList();
  }, []);

  const getmealOptionsList = () => {
    axios
      .post(requests.getMealTypeList, { mealVoucherId: 1 })
      .then((res) => {
        //mealOptionsId
        //name

        const processData = res.data.map((item) => ({
          value: item.mealTypeId,
          name: item.mealName,
        }));
        console.log(res.data);
        setMealsoption(processData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const postToApi = async (values) => {
    console.log(values);
    console.log(JSON.stringify(values, null, 2));
    await axios
      .post(requests.uploadMealTicket, values)
      .then((res) => {
        console.log(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div>
      <Titlebanner title="Meals Ticket Creation" />
      <Card>
        <CardBody>
          <Row>
            <Col>
              <Field
                name="mealOptionsId"
                type="select"
                label="Meal Type"
                customfeild={mealsoption}
                component={RenderField.renderOptionField}
              />
            </Col>
            <Col>
              <Field
                name="ticketNumberExcel"
                component={RenderExcelUploadField}
              />
            </Col>
          </Row>

          <div className="float-right">
            <Button
              color="primary"
              onClick={handleSubmit((values) =>
                postToApi({
                  ...values,
                  pill: 1,
                })
              )}
            >
              Save
            </Button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default reduxForm({
  form: "MealsTicketCreation",
})(MealsTicketCreation);
